/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MdmMergeEvent } from './MdmMergeEvent';
import {
    MdmMergeEventFromJSON,
    MdmMergeEventFromJSONTyped,
    MdmMergeEventToJSON,
    MdmMergeEventToJSONTyped,
} from './MdmMergeEvent';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface MergeEventsResponse
 */
export interface MergeEventsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MergeEventsResponse
     */
    success?: boolean;
    /**
     * 
     * @type {Array<MdmMergeEvent>}
     * @memberof MergeEventsResponse
     */
    data?: Array<MdmMergeEvent>;
    /**
     * 
     * @type {string}
     * @memberof MergeEventsResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof MergeEventsResponse
     */
    userTimezone?: string;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof MergeEventsResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof MergeEventsResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the MergeEventsResponse interface.
 */
export function instanceOfMergeEventsResponse(value: object): value is MergeEventsResponse {
    return true;
}

export function MergeEventsResponseFromJSON(json: any): MergeEventsResponse {
    return MergeEventsResponseFromJSONTyped(json, false);
}

export function MergeEventsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeEventsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(MdmMergeEventFromJSON)),
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function MergeEventsResponseToJSON(json: any): MergeEventsResponse {
    return MergeEventsResponseToJSONTyped(json, false);
}

export function MergeEventsResponseToJSONTyped(value?: MergeEventsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(MdmMergeEventToJSON)),
        'errorMessage': value['errorMessage'],
        'userTimezone': value['userTimezone'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

